const state = {
    processResources: [],
    abilityDetails: [],
    resourceDetails: [],
    existingKeyResources: [],
};

const mutations = {
    setProcessResources(state, value) {
        state.processResources = value;
    },
    setAbilityDetails(state, value) {
        state.abilityDetails = value;
    },
    setResourceDetails(state, value) {
        state.resourceDetails = value;
    },
    setExistingKeyResources(state, value) {
        state.existingKeyResources = value;
    },
};

const actions = {};

const getters = {
    processResources: (state) => state.processResources,
    abilityDetails: (state) => state.abilityDetails,
    resourceDetails: (state) => state.resourceDetails,
    existingKeyResources: (state) => state.existingKeyResources,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
